import Fade from 'react-reveal/Fade';
export default function ContactUs() {
	return (
		<div className="bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
			<div className="relative max-w-xl mx-auto">
				<svg
					className="absolute left-full transform translate-x-1/2"
					width={404}
					height={404}
					fill="none"
					viewBox="0 0 404 404"
					aria-hidden="true"
				>
					<defs>
						<pattern
							id="85737c0e-0916-41d7-917f-596dc7edfa27"
							x={0}
							y={0}
							width={20}
							height={20}
							patternUnits="userSpaceOnUse"
						>
							<rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
						</pattern>
					</defs>
					<rect width={404} height={404} fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
				</svg>
				<svg
					className="absolute right-full bottom-0 transform -translate-x-1/2"
					width={404}
					height={404}
					fill="none"
					viewBox="0 0 404 404"
					aria-hidden="true"
				>
					<defs>
						<pattern
							id="85737c0e-0916-41d7-917f-596dc7edfa27"
							x={0}
							y={0}
							width={20}
							height={20}
							patternUnits="userSpaceOnUse"
						>
							<rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
						</pattern>
					</defs>
					<rect width={404} height={404} fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)" />
				</svg>
				<Fade up>
					<div className="text-center">
						<h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
							Contact Us
						</h2>
						<p className="mt-4 text-lg leading-6 text-gray-500">
							Whether you’re a large enterprise, small company or individual, we’d love to work together
							with you! Feel free to get in touch!
						</p>
					</div>
					<div className="mt-12">
						<form action="#" method="POST" className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
							<div>
								<label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
									First name
								</label>
								<div className="mt-1">
									<input
										type="text"
										name="first_name"
										id="first_name"
										autoComplete="given-name"
										className="py-3 px-4 block w-full shadow-sm focus:ring-rose-500 focus:border-rose-500 border-gray-300 rounded-md"
									/>
								</div>
							</div>
							<div>
								<label htmlFor="last_name" className="block text-sm font-medium text-gray-700">
									Last name
								</label>
								<div className="mt-1">
									<input
										type="text"
										name="last_name"
										id="last_name"
										autoComplete="family-name"
										className="py-3 px-4 block w-full shadow-sm focus:ring-rose-500 focus:border-rose-500 border-gray-300 rounded-md"
									/>
								</div>
							</div>

							<div className="sm:col-span-2">
								<label htmlFor="email" className="block text-sm font-medium text-gray-700">
									Email
								</label>
								<div className="mt-1">
									<input
										id="email"
										name="email"
										type="email"
										autoComplete="email"
										className="py-3 px-4 block w-full shadow-sm focus:ring-rose-500 focus:border-rose-500 border-gray-300 rounded-md"
									/>
								</div>
							</div>
							<div className="sm:col-span-2">
								<label htmlFor="message" className="block text-sm font-medium text-gray-700">
									Message
								</label>
								<div className="mt-1">
									<textarea
										id="message"
										name="message"
										rows={4}
										className="py-3 px-4 block w-full shadow-sm focus:ring-rose-500 focus:border-rose-500 border-gray-300 rounded-md"
										defaultValue={''}
									/>
								</div>
							</div>
							<div className="sm:col-span-2">
								<button
									type="submit"
									className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-rose-600 hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500"
								>
									Let's talk
								</button>
							</div>
						</form>
					</div>
				</Fade>
			</div>
		</div>
	);
}
